import React from 'react'
import CrudManager from "../../utils/Crud-Manager/CrudManager";
import schema from "./Data/AlertCRUDConfig.json";
import { Box } from "@mui/material";
import PageHeader from "../../components/PageHeader";
function HomeAlert() {
  return (
    <Box sx={{ display: "flex" }}>
      <Box sx={{ flexGrow: 1, marginTop:0, marginLeft: 15,  marginRight: 15, marginBottom:15}} >
      <PageHeader pageTitle="Manage Home Alert " />
        <CrudManager
          data={schema}
          actionBtnName="Add Home Alert "
          createFormTitle="Add Home Alert"
          updateFormTitle="Update Home Alert"
        />
      </Box>
    </Box>
  )
}

export default HomeAlert
